import { useState } from 'react';
import type { FC } from 'react';

import { useMediaQuery } from '@react-hookz/web';

import { closeNextBestActionCard } from 'src/app/state/actions/homescreen';
import { useDispatch } from 'src/app/state/store';
import type { NextBestActionsProps, NextBestActionVariation } from 'src/app/types';

import NextBestActionCard from './NextBestActionCard';
import { NextBestActionsContainer } from './styles';

const ANIMATION_DURATION = 900;
export const NextBestActions: FC<NextBestActionsProps> = ({ visibleNextBestActionCard }) => {
  const dispatch = useDispatch();
  const sm_down = useMediaQuery('(max-width: 576px)');
  const [isDismissing, setIsDismissing] = useState(false);
  if (sm_down === undefined) return null;

  const handleDismissNBACard = (variation: NextBestActionVariation) => {
    setIsDismissing(true);
    setTimeout(() => {
      dispatch(closeNextBestActionCard(variation));
    }, ANIMATION_DURATION);
  };

  return (
    <NextBestActionsContainer isDismissing={isDismissing}>
      <NextBestActionCard
        handleDismissNBACard={handleDismissNBACard}
        isDismissing={isDismissing}
        visibleNextBestActionCard={visibleNextBestActionCard}
      />
    </NextBestActionsContainer>
  );
};
